// extracted by mini-css-extract-plugin
export default {"container":"ResetPasswordPage_container__iLv+r","emailFieldset":"ResetPasswordPage_emailFieldset__wuf26","passwordFieldset":"ResetPasswordPage_passwordFieldset__U4qON"};